import { NetworkActionErrorHandler } from "@core/api/error-handling-api-service";
import { observable } from "micro-observables";

interface NetworkActionErrorEvent {
	date: Date;
	error: unknown;
	title?: string;
	message?: string;
}

export class NetworkActionsErrorsManager implements NetworkActionErrorHandler {
	private readonly _actionErrors = observable<NetworkActionErrorEvent | null>(null);
	public actionErrors = this._actionErrors.readOnly();

	clearError(): void {
		this._actionErrors.set(null);
	}

	reportError(error: unknown, message?: string, title?: string): void {
		this._actionErrors.set({ date: new Date(), error: error, title, message });
	}
}
